'use strict';

import angular from 'angular';

const currencySymbolFactory = (currencies) => {
  'ngInject';

  return (currencyCode) => {
    const currency = currencies.filter(currency => currency.code === currencyCode)[0] || {};

    return currency.symbol || currencyCode;
  };
};

export default angular
  .module('service.currencySymbol', [])
  .factory('currencySymbol', currencySymbolFactory)
  .name;



// WEBPACK FOOTER //
// ./app/src/services/currency_symbol.service.js